<template>
  <div class="white-noise-audio">
    <audio ref="audio1" @pause="onPause" @play="onPlay" webkit-playsinline class="white-noise-audio"></audio>
    <audio ref="audio2" @pause="onPause" @play="onPlay" webkit-playsinline class="white-noise-audio"></audio>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

export default {
  name: "CamstudyWhiteNoiseAudio",
  data() {
    return {
      audioList: [],
      audio: null,
      playStatus: 'pause',
      loopHandler: null,
    }
  },
  created() {
    this.$roomApi.addEventListeners((this._Events = _Events()), this)
  },
  mounted() {
    this.audioList = [this.$refs.audio1, this.$refs.audio2];
    this.audio = this.audioList[0];
    this.loopHandler = this.loop.bind(this);
  },
  computed: {
  ...mapGetters('user', [
      'me'
    ]),
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
  },
  watch: {
    playStatus(status) {
      const whiteNoiseStatus = status === 'play' ? 'on':'off';
      this.changeWhiteNoiseStatus({userId: this.me.userId, whiteNoiseStatus});
    },
  },
  methods: {
    ...mapActions('camstudy', [
      'changeWhiteNoiseStatus'
    ]),
    play(currentWhiteNoise, whiteNoise) {
      if(currentWhiteNoise?.whiteNoiseId === whiteNoise.whiteNoiseId) {
        if(this.audio.paused) {
          this.audio.play();
        } else {
          this.audio.pause();
        }
        return;
      }

      this.audio.src = whiteNoise.src;
      this.audio.play();
    },
    loop(e) {
      const audio = e.target;
      const buffer = 2.0; // 재생 종료 2초 전 체크
      if (isNaN(audio.duration) || audio.currentTime < audio.duration - buffer) {
        return;
      }
      // 중복 호출 방지를 위해 이벤트 리스너 제거
      audio.removeEventListener('timeupdate', this.loopHandler);

      // 현재 오디오 인덱스를 찾아 다음 오디오로 변경 (순환)
      const currentIdx = this.audioList.indexOf(audio);
      const nextIdx = (currentIdx + 1) % this.audioList.length;
      this.audio = this.audioList[nextIdx];

      // 다음 오디오에 현재 오디오의 src를 할당한 후 재생
      this.audio.src = audio.src;
      this.audio.play();
    },
    onPause(e) {
      if (e.target === this.audio) {
        this.playStatus = 'pause';
      }
    },
    onPlay(e) {
      this.playStatus = 'play';
      e.target.removeEventListener('timeupdate', this.loopHandler);
      e.target.addEventListener('timeupdate', this.loopHandler);
    },
  }
}

function _Events() {
  return {
    room_changeWhiteNoise: function(e) {
      const {currentWhiteNoise, whiteNoise} = e.data;
      this.play(currentWhiteNoise, whiteNoise);
    }
  }
}

</script>

<style scoped lang="scss">

</style>